<template>
  <div ref="root" class="mmg-storefront mmg-home home fusion-body">
    <div id="wrapper">
      <div id="home" class="home-anchor" />
      <SiteHeader />
      <HomeHeroSlider />

      <main id="main" role="main" class="clearfix">
        <div class="fusion-row">
          <section id="content" class="home-content">
            <article id="post-2" class="post-2 page type-page status-publish hentry">
              <div class="post-content">
                <!-- 展会公告 -->
                <section class="fusion-fullwidth home-section home-section--muted">
                  <div class="fusion-builder-row fusion-row">
                    <div class="fusion-layout-column fusion-one-full home-column">
                      <div class="fusion-column-wrapper home-column-wrapper">
                        <div class="fusion-title fusion-title-center fusion-title-size-two">
                          <div class="home-expo-notice">
                            <h2 class="title-heading-center home-expo-title">
                              {{ $t('home.expoNoticeTitle') }}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- 产品分类 -->
                <section class="fusion-fullwidth home-section home-section--plain home-section--categories">
                  <div class="fusion-builder-row fusion-row home-categories-row">
                    <div
                      v-if="productCategories.length"
                      class="fusion-layout-column fusion-one-full home-column home-categories-wrap"
                    >
                      <div class="fusion-column-wrapper home-column-wrapper">
                        <div class="home-categories-grid">
                          <router-link
                            v-for="category in productCategories"
                            :key="category.id"
                            :to="categoryProductLink(category.slug)"
                            class="home-category-card"
                          >
                            <div class="home-category-card__media">
                              <img
                                v-if="categoryImageUrl(category)"
                                :src="categoryImageUrl(category)"
                                :alt="$categoryName(category)"
                                class="home-category-card__img"
                                loading="lazy"
                                decoding="async"
                                @error="onCategoryImageError($event)"
                              />
                              <span v-else class="home-category-card__placeholder" aria-hidden="true" />
                            </div>
                            <h2 class="home-category-title">
                              <strong>{{ $categoryName(category) }}</strong>
                            </h2>
                          </router-link>
                        </div>
                      </div>
                    </div>

                    <div class="fusion-layout-column fusion-one-full home-column">
                      <div class="fusion-column-wrapper home-column-wrapper">
                        <div class="fusion-button-wrapper fusion-aligncenter">
                          <router-link
                            to="/products"
                            class="fusion-button button-flat fusion-button-round button-large button-default button-1"
                          >
                            <span class="fusion-button-text">{{ $t('home.viewAllProducts') }}</span>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- About：OEM 图 + 介绍（左右与产品齐平，图文顶底对齐） -->
                <section class="fusion-fullwidth home-section home-section--plain home-about-section">
                  <div class="home-about">
                    <div class="home-about__media">
                      <img
                        src="/1.jpg"
                        alt="OEM / ODM"
                        class="home-about__img"
                      />
                    </div>
                    <div class="home-about__copy">
                      <div class="home-about__text">
                        <p v-for="(paragraph, index) in aboutParagraphs" :key="'about-' + index">
                          {{ paragraph }}
                        </p>
                      </div>
                      <div class="home-about__actions">
                        <router-link
                          to="/about"
                          class="fusion-button button-flat fusion-button-round button-small button-default button-2"
                        >
                          <span class="fusion-button-text">{{ $t('common.viewMore') }}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Why choose us 标题 -->
                <section class="fusion-fullwidth home-section home-section--muted home-section--spacious-top">
                  <div class="fusion-builder-row fusion-row">
                    <div class="fusion-layout-column fusion-one-full home-column">
                      <div class="fusion-column-wrapper home-column-wrapper">
                        <div class="fusion-title fusion-title-center fusion-title-size-two">
                          <h2 class="title-heading-center home-why-title">
                            {{ $t('home.whyChooseUs') }}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Why choose us 内容 -->
                <section class="fusion-fullwidth home-section home-section--muted">
                  <div class="fusion-builder-row fusion-row">
                    <div class="fusion-layout-column fusion-one-full home-column">
                      <div class="fusion-column-wrapper home-column-wrapper">
                        <div
                          class="fusion-content-boxes fusion-columns-3 fusion-content-boxes-1 content-boxes-icon-with-title content-left"
                        >
                          <div
                            v-for="(item, index) in whyChooseUsItems"
                            :key="'why-' + index"
                            class="fusion-column content-box-column fusion-content-box-hover"
                            :class="{
                              'content-box-column-first-in-row': index % 3 === 0,
                              'content-box-column-last': index === whyChooseUsItems.length - 1
                            }"
                          >
                            <div class="col content-wrapper link-area-link-icon icon-hover-animation-fade">
                              <div class="heading heading-with-icon icon-left">
                                <div class="icon">
                                  <i
                                    class="fontawesome-icon circle-yes home-feature-icon"
                                    :class="item.icon"
                                    aria-hidden="true"
                                  />
                                </div>
                                <h2 class="content-box-heading">{{ item.title }}</h2>
                              </div>
                              <div class="content-container home-feature-body">
                                <p v-html="item.body" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import HomeHeroSlider from '@/components/HomeHeroSlider.vue'
import {
  categoryProductLink,
  fetchPublicCategories,
  mapStorefrontCategories,
  resolveUploadUrl
} from '@/api/categories'

export default {
  name: 'HomePage',
  components: { SiteHeader, SiteFooter, HomeHeroSlider },
  data() {
    return {
      productCategories: []
    }
  },
  computed: {
    aboutParagraphs() {
      void this.currentLocale
      return this.$tm('home.aboutParagraphs') || []
    },
    whyChooseUsItems() {
      void this.currentLocale
      return this.$tm('home.whyItems') || []
    }
  },
  mounted() {
    document.body.classList.add('home')
    document.title = this.$t('pageTitle.home')
    this.loadProductCategories()
  },
  watch: {
    currentLocale() {
      document.title = this.$t('pageTitle.home')
    }
  },
  beforeUnmount() {
    document.body.classList.remove('home')
  },
  methods: {
    categoryProductLink,
    categoryImageUrl(category) {
      if (!category) return ''
      return resolveUploadUrl(category.image_url || category.image_path || '')
    },
    onCategoryImageError(event) {
      event.target.style.display = 'none'
    },
    async loadProductCategories() {
      try {
        const res = await fetchPublicCategories()
        this.productCategories = mapStorefrontCategories(res.data?.items || [])
      } catch {
        this.productCategories = []
      }
    }
  }
}
</script>

<style scoped>
.home-anchor {
  position: relative;
  top: -1px;
}

.home-content {
  width: 100%;
}

.mmg-home :deep(#main) {
  padding-left: 6px;
  padding-right: 6px;
}

.mmg-home :deep(#main > .fusion-row) {
  max-width: min(1680px, calc(100vw - 12px));
  padding-left: 0;
  padding-right: 0;
}

/* 首页各区块（产品 / 介绍等）统一拉满同一内容宽，去掉 1100px 限制 */
.mmg-home :deep(.post-content > .fusion-fullwidth > .fusion-builder-row.fusion-row) {
  max-width: none !important;
  width: 100% !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  box-sizing: border-box;
}

.home-section--categories :deep(.home-categories-row) {
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.mmg-home :deep(.mmg-about-row) {
  max-width: none !important;
  width: 100% !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* 介绍区：独立布局，避开 fusion 浮动列冲突 */
.home-about-section {
  padding-left: 0;
  padding-right: 0;
}

.home-about {
  display: flex;
  align-items: flex-start;
  gap: 300px;
  width: 100%;
  max-width: none;
  margin: 0;
  box-sizing: border-box;
}

/* 框紧贴图片（由图片撑开），避免左右留白；不用绝对定位以免高度塌成 0 */
.home-about__media {
  flex: 0 1 42%;
  width: 42%;
  max-width: 520px;
  min-width: 0;
  margin-right: 0;
  border: 1px solid #e5e5e5;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
  line-height: 0;
}

.home-about__img {
  display: block;
  width: 100%;
  height: auto;
  vertical-align: top;
  object-fit: contain;
  object-position: center center;
}

.home-about__copy {
  flex: 1 1 0;
  min-width: 0;
  margin-left: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: stretch;
  box-sizing: border-box;
}

.home-about__text p {
  margin: 0 0 1em;
  color: var(--mmg-text, #747474);
}

.home-about__text p:last-child {
  margin-bottom: 0;
}

.home-about__actions {
  flex: 0 0 auto;
  margin-top: auto;
  padding-top: 16px;
}

@media (max-width: 800px) {
  .home-about {
    flex-direction: column;
    gap: 24px;
  }

  .home-about__media {
    width: 100%;
    max-width: 100%;
    flex: 0 0 auto;
  }

  .home-about__copy {
    padding-left: 0;
  }

  .home-about__actions {
    margin-top: 16px;
  }
}

.home-section {
  padding-top: 20px;
  padding-bottom: 20px;
}

.home-section--muted {
  background-color: #f6f6f6;
}

.home-section--plain {
  background-color: #fff;
}

.home-section--spacious-top {
  padding-top: 50px;
}

.home-column {
  margin-top: 0;
  margin-bottom: 20px;
}

.home-column-wrapper {
  padding: 0;
}

.home-expo-notice {
  max-width: none;
  margin: 0 auto;
}

.home-expo-title {
  margin: 0 0 8px;
  font-size: 30px;
  font-weight: 700;
  color: #000;
  line-height: 1.35;
}

.home-categories-wrap {
  margin-bottom: 0;
}

.home-categories-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px 10px;
}

.home-category-card {
  display: block;
  text-decoration: none;
  color: inherit;
  transition: opacity 0.2s ease;
}

.home-category-card:hover {
  opacity: 0.88;
}

.home-category-card__media {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #f7f7f7;
  margin-bottom: 14px;
}

.home-category-card__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.home-category-card__placeholder {
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #e8e8e8 0%, #d0d0d0 100%);
}

.home-category-title {
  margin: 0;
  text-align: center;
  font-size: 22px;
  font-weight: 400;
}

@media (max-width: 1024px) {
  .home-categories-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 10px;
  }
}

@media (max-width: 480px) {
  .mmg-home :deep(#main) {
    padding-left: 6px;
    padding-right: 6px;
  }

  .home-categories-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.home-about-text p {
  margin: 0 0 1em;
}

.home-why-title {
  margin: 0 0 31px;
  font-size: 32px;
  font-weight: 700;
  color: #000;
  line-height: 1.35;
}

.home-feature-icon {
  display: inline-block;
  box-sizing: content-box;
  width: 42px;
  height: 42px;
  line-height: 42px;
  border: 1px solid #333;
  border-radius: 50%;
  background-color: #333;
  color: #fff;
  font-size: 23px;
  text-align: center;
}

.home-feature-body {
  color: #747474;
}

.mmg-storefront .fusion-content-boxes-1 .content-box-heading {
  font-size: 20px;
  line-height: 23px;
  margin: 0;
}

.home-section .fusion-content-boxes {
  margin-bottom: 60px;
}
</style>
